"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSpacesFromPhoneNumber = exports.removeSpacesFromPhoneNumber = exports.replaceHtmlSpecialCharacters = exports.replaceAll = void 0;
const lodash_1 = require("lodash");
const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(find, "g"), replace);
};
exports.replaceAll = replaceAll;
const replaceHtmlSpecialCharacters = (text) => {
    let replacedText = text;
    const specialCharacters = {
        '&#038;': '&',
        '&amp;': '&',
        '&#62;': '>',
        '&gt;': '>',
        '&#60;': '<',
        '&lt;': '<',
        '&#39;': "'",
        '&apos;': "'",
        '&quot;': '"',
        '&#34;': '"',
        '&#8217;': '’',
        '&rsquo;': '’',
        '&#8211;': '-',
    };
    Object.entries(specialCharacters).forEach(([specialCharacter, replacedCharacter]) => {
        replacedText = (0, lodash_1.replace)(replacedText, new RegExp(specialCharacter, 'g'), replacedCharacter);
    });
    return replacedText;
};
exports.replaceHtmlSpecialCharacters = replaceHtmlSpecialCharacters;
const removeSpacesFromPhoneNumber = (str = "") => {
    return str.replace(/\s/g, "");
};
exports.removeSpacesFromPhoneNumber = removeSpacesFromPhoneNumber;
const addSpacesFromPhoneNumber = (str = "") => {
    if (str.substring(0, 3) === "+48") {
        return `${str.substring(0, 3)} ${str.substring(3, 6)} ${str.substring(6, 9)} ${str.substring(9)}`;
    }
    return `${str.substring(0, 3)} ${str.substring(3, 6)} ${str.substring(6)}`;
};
exports.addSpacesFromPhoneNumber = addSpacesFromPhoneNumber;
//# sourceMappingURL=index.js.map